import qs from "qs";
import { isVideoUploadSortDirection, isVideoUploadSortField, type VideoUploadSortDirection } from "./videoUploadSortFields";

export interface VideoUploadsQueryParams {
	preset: string;
	page: number;
	limit: number;
	order?: {
		name?: string;
		sort?: VideoUploadSortDirection;
	};
	filters?: Array<{
		field: string;
		type: string;
		value: string | number | { start?: string; end?: string } | string[];
	}>;
}

export function buildVideoUploadsQueryString(params: VideoUploadsQueryParams): string {
	const { page, limit, order, filters } = params;
	const query: Record<string, unknown> = { page, limit };

	if (
		order !== undefined &&
		isVideoUploadSortField(order.name) &&
		isVideoUploadSortDirection(order.sort)
	) {
		query.order = { name: order.name, sort: order.sort };
	}

	if (filters !== undefined && filters.length > 0) {
		query.filters = filters;
	}

	return qs.stringify(query);
}
